import type { ActionSearchRequestDto } from '../types/search-request.dto';
import type { ActionSearchRequestModel } from '../types/search-request.model';

import { toSearchRequestDto } from '@/features/Shared/model/mappers/search-request.dt';

export const toActionSearchRequest = (model: ActionSearchRequestModel): ActionSearchRequestDto => {
	return {
		...toSearchRequestDto(model),
		title: model.title,
	};
};
